import { capturePdfFrameIntoHTML } from '@huspy/forge/shared';
import { CITIZEN_STATUS, EMPLOYMENT_STATUS } from '@modules/opportunities/entities/opportunity/const';

export const downloadFile = (file: Blob, fileName: string = 'proposal.pdf') => {
  const url = window.URL.createObjectURL(file);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.append(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const initProposalDownload = async (
  fileName: string,
  proposalElementId: string,
  downloadProposalPDF: ({ html }: { html: string }) => Promise<Blob>
) => {
  const cleanFileName = fileName.replaceAll(/["*/:<>?\\|]/g, '_');
  const html = await capturePdfFrameIntoHTML(proposalElementId, cleanFileName);
  if (html) {
    const blob = await downloadProposalPDF({ html });
    downloadFile(blob, fileName);
  } else {
    throw new Error('Proposal html couldn\'t be extraced');
  }
};

export const mapToTranslationKey = (key: string): string => ({
  [CITIZEN_STATUS.national]: 'clients.applicationDetails.residencyStatusNational',
  [CITIZEN_STATUS.resident]: 'clients.applicationDetails.residencyStatusResident',
  [CITIZEN_STATUS.nonResident]: 'clients.applicationDetails.residencyStatusNonResident',
  [EMPLOYMENT_STATUS.selfEmployed]: 'clients.applicationDetails.employmentStatusSelfEmployed',
  [EMPLOYMENT_STATUS.salaried]: 'clients.applicationDetails.employmentStatusSalaried',
  [EMPLOYMENT_STATUS.government]: 'clients.applicationDetails.employmentStatusGovernment',
  [EMPLOYMENT_STATUS.temporary]: 'clients.applicationDetails.employmentStatusTemporary',
  [EMPLOYMENT_STATUS.unemployed]: 'clients.applicationDetails.employmentStatusUnemployed',
  [EMPLOYMENT_STATUS.other]: 'clients.applicationDetails.employmentStatusOther',
})[key] ?? key;
